<template>
  <div>
    <a ng-show="false" id="exportLink" href="/ExcelFileDownload"></a>
    <div v-show="tableSwapLoading">
      <br /><br /><br /><br />
      <br /><br /><br /><br />
      <v-progress-circular :size="200" :width="7" color="blue" indeterminate
        ><b></b
      ></v-progress-circular>
    </div>

    <div class="table-padding" v-show="!tableSwapLoading">
      <v-row class="mt-0">
        <v-col>
          <h1 class="font-weight-light pb-0">
            <v-row justify="center"> <span class="grey-text">{{tableTitle}}</span>
              <v-dialog v-model="dialog" persistent width="250">
                <template v-slot:activator="{ on, attrs }">

                  <div v-show="showTitleToolTip" class="ml-2">
                    <tool-tip
                      text=""
                      hoverText="Estimated out of bundle spend since the last invoice date, excluding any monthly service charges"
                      position="bottom"
                      :maxTextLength="1000"
                      iconName="mdi-information-outline"
                      iconSize="30"
                    >
                    </tool-tip>
                  </div>

                  <div
                    v-show="$route.params.tablename == 'service_response_line'"
                    style="margin-left: 200px"
                  >
                    <v-btn
                      v-show="!exportInProgress"
                      color="green darken-1 font-weight-bold"
                      text
                      @click="getAllChangeRequests()"
                    >
                      DOWNLOAD ALL SERVICE REQUESTS
                    </v-btn>

                    <v-progress-circular
                      v-show="exportInProgress"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>

                  </div>

                  <a class="ml-3" v-on="on" v-bind="attrs"
                    ><v-icon
                      v-show="canExport && !exportInProgress"
                      large
                      color="maintel-dark-green"
                      >mdi-file-excel</v-icon
                    >
                    <v-progress-circular
                      v-show="exportInProgress"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </a>

                  <span v-show="loadedWithSearchParam.length > 0"
                    >&nbsp;({{ loadedWithSearchParam }})</span
                  >
                </template>
                <v-card>
                  <v-card-title class="text-h7">
                    Confirm Excel Export
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="maintel-green darken-1 font-weight-bold"
                      text
                      @click="exportTable()"
                    >
                      CONFIRM
                    </v-btn>
                    <v-btn
                      color="maintel-green darken-1 font-weight-bold"
                      text
                      @click="dialog = false"
                    >
                      CANCEL
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="deleteDialog" persistent width="250">
                <v-card>
                  <v-card-title class="text-h7">
                    Confirm Delete Alert
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="maintel-green darken-1 font-weight-bold"
                      text
                      @click="confirmDeleteAlert()"
                    >
                      CONFIRM
                    </v-btn>
                    <v-btn
                      color="maintel-green darken-1 font-weight-bold"
                      text
                      @click="deleteDialog = false"
                    >
                      CANCEL
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="addDialog" persistent width="1000">
                <v-card>
                  <v-container>
                    <v-row>
                      <v-col class="d-flex">
                        <v-card-title class="text-h7">
                          <v-icon class="mr-2">
                            mdi-plus-circle-outline
                          </v-icon>

                          Adding Portal Alert
                        </v-card-title>
                      </v-col>
                      <v-col class="d-flex mt-2 col-8 mr-4">
                        <v-tabs
                          color="deep-purple accent-4"
                          right
                          v-model="tabNumber"
                        >
                          <v-tab
                            @click="
                              alertTypeSelected('BUNDLE');
                              tabNumber = 0;
                            "
                            value="0"
                            >BUNDLE ALERT</v-tab
                          >
                          <v-tab
                            @click="
                              alertTypeSelected('DATA');
                              tabNumber = 1;
                            "
                            value="1"
                            >DATA USAGE ALERT</v-tab
                          >
                          <v-tab
                            @click="
                              alertTypeSelected('SPEND');
                              tabNumber = 2;
                            "
                            value="2"
                            >SPEND ALERT</v-tab
                          >
                        </v-tabs>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <br />
                  <v-card-text>
                    <v-icon left> mdi-information-outline </v-icon>

                    {{ alertText }}
                  </v-card-text>
                  <v-divider></v-divider>
                  <br />
                  <v-card-text>
                    <v-checkbox
                      class="ma-0 pa-0 mb-4"
                      v-model="newPortalAlert.global"
                      label="Global Alert"
                      :hint="globalAlertText"
                      persistent-hint
                    ></v-checkbox>

                    <v-textarea
                      v-model="newPortalAlert.description"
                      label="Enter Alert Description (Optional)"
                      prepend-inner-icon="mdi-text"
                      clearable
                      outlined
                      dense
                      hint="Optional text associated with an alert. For example - the reason you're adding this alert"
                      persistent-hint
                      class="mb-2"
                    ></v-textarea>

                    <v-text-field
                      v-model="newPortalAlert.email"
                      label="Enter Email Address"
                      prepend-inner-icon="mdi-email"
                      clearable
                      outlined
                      dense
                      hint="Alerts will be sent to the provided email address"
                      persistent-hint
                      class="mb-2"
                    ></v-text-field>

                    <v-autocomplete
                      label="Enter Network Serial Number"
                      v-if="!newPortalAlert.global"
                      prepend-inner-icon="mdi-phone"
                      clearable
                      filled
                      outlined
                      dense
                      :items="allNumbersForAccount"
                      v-model="newPortalAlert.networkSerialNumber"
                      hint="Alerts will be set for the selected network serial number"
                      persistent-hint
                    >
                    </v-autocomplete>

                    <div v-if="newPortalAlert.type != 'BUNDLE'">
                      <v-text-field
                        class="mt-2"
                        label="Enter Lower Bound Threshold"
                        v-model.number="newPortalAlert.lowerThreshold"
                        persistent-hint
                        min="0"
                        single-line
                        outlined
                        :hint="lowerThresholdTextHint"
                        dense
                        type="number"
                      >
                        <v-label
                          style="white-space: nowrap; overflow: hidden"
                          class="pt-0"
                          slot="prepend"
                        >
                          ({{ alertSymbol }}) Lower Bound &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp;
                        </v-label>
                      </v-text-field>

                      <v-text-field
                        class="mt-2"
                        label="Enter Upper Bound Threshold"
                        v-model.number="newPortalAlert.upperThreshold"
                        single-line
                        :hint="upperThresholdTextHint"
                        outlined
                        min="0"
                        dense
                        persistent-hint
                        type="number"
                      >
                        <v-label
                          style="white-space: nowrap; overflow: hidden"
                          class="pt-0"
                          slot="prepend"
                        >
                          ({{ alertSymbol }}) Upper Bound &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp;
                        </v-label>
                      </v-text-field>
                    </div>

                    <div v-if="newPortalAlert.type == 'BUNDLE'">
                      <v-slider
                        v-model="newPortalAlert.lowerThreshold"
                        :max="100"
                        :min="1"
                        step="1"
                        :label="'(' + alertSymbol + ') ' + 'Lower Bound'"
                        class="align-center mb-2"
                        :hint="lowerThresholdTextHint"
                        persistent-hint
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="newPortalAlert.lowerThreshold"
                            class="mt-0 pt-0"
                            type="number"
                            style="width: 60px"
                            oninput="if (this.value > 100) {this.value == 100}"
                          ></v-text-field>
                        </template>
                      </v-slider>
                      <v-slider
                        v-model="newPortalAlert.upperThreshold"
                        :max="100"
                        :min="1"
                        step="1"
                        :label="'(' + alertSymbol + ') ' + 'Upper Bound'"
                        class="align-center"
                        :hint="upperThresholdTextHint"
                        persistent-hint
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="newPortalAlert.upperThreshold"
                            class="mt-0 pt-0"
                            type="number"
                            :min="1"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </div>

                    <span v-if="alertErrorMessage.length > 0"> <br /></span>
                    <p
                      class="red--text"
                      v-for="(error, index) in alertErrorMessage"
                      :key="index"
                    >
                      {{ error }}
                    </p>
                  </v-card-text>
                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-col class="text-right">
                      <v-btn
                        color="green darken-1 font-weight-bold"
                        text
                        @click="confirmAddAlert()"
                      >
                        CONFIRM
                      </v-btn>
                      <v-btn
                        color="green darken-1 font-weight-bold"
                        text
                        @click="addDialog = false"
                      >
                        CANCEL
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="markDialog" persistent width="300">
                <v-card>
                  <v-card-title class="text-h7">
                    Confirm Mark
                    <span v-if="markAll">&nbsp;All&nbsp;</span> Read
                  </v-card-title>
                  <v-card-actions>
                    <v-btn
                      color="green darken-1 font-weight-bold"
                      text
                      @click="confirmMarkAlert()"
                    >
                      CONFIRM
                    </v-btn>
                    <v-btn
                      color="green darken-1 font-weight-bold"
                      text
                      @click="markDialog = false"
                    >
                      CANCEL
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </h1>
        </v-col>
      </v-row>
      <span v-if="dataTableFilters == null"><br /></span>
      <v-row class="mt-0" v-if="dataTableFilters != null">
        <v-col class="pb-0 pl-0 pr-0">
          <div class="pl-3 pr-3 pt-3">
            <v-card color="maintel-contrast2" outlined class="pa-2 pl-5 mb-6">
              <v-row class="mb-0 mt-0">
                <div
                  v-for="filter in dataTableFilters"
                  :key="filter.filterFieldName"
                  fluid
                >
                  <v-col
                    class="pa-0 pr-2"
                    v-if="
                      (filter.filterType == 'search' &&
                        $route.params.tablename != 'invoice_line') ||
                      filter.filterType != 'search'
                    "
                  >
                    <v-select
                      v-if="filter.filterType == 'select'"
                      :items="filter.filterOptions"
                      :label="filter.filterDisplayName"
                      v-model="filter.filterValue"
                      dense
                      solo
                      hide-details
                      v-on:change="getItems()"
                    ></v-select>

                    <v-text-field
                      v-if="filter.filterType == 'search'"
                      outlined
                      :label="filter.filterDisplayName"
                      color="primary"
                      v-model="filter.filterValue"
                      full-width
                      :hint="textHint"
                      class="capital"
                      hide-details
                      dense
                    >
                    </v-text-field>

                    <v-btn
                      v-if="filter.filterType == 'check_box'"
                      class="pb-7 pa-2 pr-3 med-chip"
                      color="maintel-dark"
                    >
                      <v-checkbox
                        hide-details
                        v-model="filter.filterValue"
                        v-bind:false-value="filter.filterOffValue"
                        v-bind:true-value="filter.filterOnValue"
                        @click="getItems()"
                        color="black"
                      >
                        <template v-slot:label>
                          <span class="black--text" id="checkboxLabel">{{
                            filter.filterDisplayName
                          }}</span>
                        </template>
                      </v-checkbox>
                    </v-btn>
                  </v-col>
                </div>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-0" v-if="this.canSearchBy.length > 0">
        <v-col class="pt-0">
          <v-text-field
            outlined
            label="Search"
            color="primary"
            append-icon="mdi-close"
            @click:append="clear()"
            v-on:keyup.enter="search(true)"
            v-model="searchValue"
            :hint="textHint"
            class="capital mt-1"
            dense
          >
          </v-text-field>
        </v-col>
        <v-col
          v-if="
            this.$route.params.tablename == 'portal_alert' ||
            this.$route.params.tablename == 'alert_record'
          "
          cols="2"
          class="pt-1"
        >
          <v-btn
            v-if="this.$route.params.tablename == 'portal_alert'"
            @click="openAddDialog()"
            color="primary"
            block
            ><b>ADD ALERT</b>

            <v-icon class="ml-2"> mdi-plus-circle-outline </v-icon>
          </v-btn>

          <v-btn
            v-if="this.$route.params.tablename == 'alert_record'"
            @click="markAlertAsRead(-1, true)"
            color="primary"
            block
            ><b>MARK ALL AS READ</b>

            <v-icon class="ml-2"> mdi-checkbox-marked-circle </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col class="pt-0">
          <v-data-table
            :headers="headers"
            :items="dataItems"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
            }"
            hide-default-header
            class="elevation-2"
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th
                    v-for="item in headers"
                    :key="item.value"
                    class="column table-header pointer center-me"
                    v-bind:class="[
                      item.sortable ? 'sortable' : 'default',
                      options.sortBy == item.value ? 'active' : '',
                    ]"
                    @click="item.sortable ? getItems(item) : null"
                  >
                    {{ item.text }}
                    <v-icon v-if="!item.sortDesc && item.sortable" small
                      >mdi-arrow-up</v-icon
                    >
                    <v-icon v-if="item.sortDesc && item.sortable" small
                      >mdi-arrow-down</v-icon
                    >
                  </th>
                </tr>
              </thead>
            </template>
            <template
              v-for="v in headers.filter((header) =>
                dateFields.includes(header.text)
              )"
              v-slot:[`item.${v.value}`]="{ value }"
            >
              <div v-bind:key="v.id" v-if="value != null">
                {{
                  buildDateString(
                    value.dayOfMonth,
                    value.monthValue,
                    value.year
                  )
                }}
              </div>
            </template>

            <template
              v-for="w in headers.filter(
                (header) => header.text == 'Bundle Description'
              )"
              v-slot:[`item.${w.value}`]="{ value }"
            >
              <div v-bind:key="w.id" class="long-header">
                {{ value }}
              </div>
            </template>

            <template
              v-for="p in headers.filter(
                (header) => header.text == 'Description'
              )"
              v-slot:[`item.${p.value}`]="{ value }"
            >
              <div v-bind:key="p.id">
                <tool-tip
                  :text="value.substring(0, 30) + '...'"
                  :hoverText="value"
                  position="top"
                >
                </tool-tip>
              </div>
            </template>

            <template
              v-for="w in headers.filter((header) => header.text == 'Delete')"
              v-slot:[`item.${w.value}`]="{ value }"
            >
              <v-btn
                @click="deletePortalAlert(value)"
                small
                :key="w.id"
                v-if="value || true"
                block
                depressed
                color="red"
                class="white--text"
              >
                <b>DELETE</b>
              </v-btn>
            </template>

            <template
              v-for="t in headers.filter((header) => header.text == 'Is Read')"
              v-slot:[`item.${t.value}`]="{ value }"
            >
              <v-btn
                @click="markAlertAsRead(value.split(':')[1])"
                small
                :key="t.id"
                v-if="value && value.split(':')[0] == 'false'"
                block
                depressed
                color="red"
                class="white--text"
              >
                <b>MARK READ</b>
              </v-btn>
              <v-btn
                small
                disabled
                :key="t.id"
                v-if="value && value.split(':')[0] == 'true'"
                block
                depressed
                color="blue"
                class="white--text"
              >
                <b>MARKED READ</b>
              </v-btn>
            </template>

            <template
              v-for="e in headers.filter(
                (header) => header.text == 'Bundle Code'
              )"
              v-slot:[`item.${e.value}`]="{ value }"
            >
              <div v-bind:key="e.id">
                <router-link :to="{ path: '/table/bundle_line/' + value }">
                  {{ value }}
                </router-link>
              </div>
            </template>

            <template
              v-for="x in headers.filter((header) =>
                percentageFields.includes(header.text)
              )"
              v-slot:[`item.${x.value}`]="{ value }"
            >
              {{ value.toFixed(2) + "%" }}
            </template>

            <template
              v-for="y in headers.filter((header) =>
                currencyFields.includes(header.text)
              )"
              v-slot:[`item.${y.value}`]="{ value }"
            >
              {{ "£" + value.toFixed(2) }}
            </template>

            <template
              v-for="z in headers.filter((header) =>
                timeFields.includes(header.text)
              )"
              v-slot:[`item.${z.value}`]="{ value }"
            >
              {{ formatTime(value) }}
            </template>

            <template
              v-for="c in headers.filter((header) =>
                unixDateFields.includes(header.text)
              )"
              v-slot:[`item.${c.value}`]="{ value }"
            >
              {{ $moment.unix(value / 1000).format("DD/MM/YYYY HH:mm:ss") }}
            </template>

            <template
              v-for="d in headers.filter((header) =>
                twoPointFields.includes(header.text)
              )"
              v-slot:[`item.${d.value}`]="{ value }"
            >
              {{ value.toFixed(2) }}
            </template>

            <template
              v-for="l in headers.filter((header) =>
                linkToMobilePanelFields.includes(header.text)
              )"
              v-slot:[`item.${l.value}`]="{ value }"
            >
              <router-link
                v-if="$route.params.tablename != 'aggregate_cdr_summary_record'"
                v-bind:key="l.id"
                :to="{ path: '/mobile/' + value }"
                >{{ value }}</router-link
              >

              <router-link
                v-if="$route.params.tablename == 'aggregate_cdr_summary_record'"
                v-bind:key="l.id"
                :to="{ path: '/table/cdr_summary_record/' + value }"
                >{{ value }}</router-link
              >
            </template>

            <template
              v-for="u in headers.filter(
                (header) => header.text == 'Invoice Number'
              )"
              v-slot:[`item.${u.value}`]="{ value }"
            >
              <router-link
                v-bind:key="u.id"
                :to="{ path: '/table/invoice_line/i' + value }"
                >{{ value }}</router-link
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ToolTip from "./ToolTip.vue";
import _ from "lodash";

export default {
  components: {
    ToolTip,
  },
  props: {
    settings: Object,
  },

  data() {
    return {
      totalItems: 0,
      tabNumber: 0,
      exportInProgress: false,
      deleteDialog: false,
      markDialog: false,
      alertSymbol: "%",
      allNumbersForAccount: [],
      allAccountChangeRequests: [],
      addDialog: false,
      newPortalAlert: {
        id: 0,
        name: "",
        description: "",
        email: "",
        global: false,
        networkSerialNumber: "",
        active: true,
        lowerThreshold: 0,
        upperThreshold: 0,
        accountNumber: 0,
      },
      // These field 'types' should all be eventually be moved to backend.
      dateFields: [
        "Service Effective Date",
        "Service Expiry Date",
        "Invoice Date",
        "Contract Start Date",
        "Contract End Date",
        "Last Invoice Date",
        "Next Invoice Date",
        "Invoice Date",
        "Raised Date",
        "Bar Date",
        "Bundle Effective Date",
        "Bundle Expiry Date",
        "Unbar Date",
        "Call Date",
        "Event Created Date",
        "Event Resolved By Date",
        "Period End",
      ],
      unixDateFields: [
        "Date Sent",
        "Created Date",
        "Deleted By",
        "Deleted On",
        "Marked On",
        "Call Due To Be Billed",
        "Created",
      ],
      percentageFields: ["Bundle Not Used Percentage", "Tax Rate"],
      currencyFields: [
        "Service Price",
        "Balance To Recover",
        "Spend Cap Amount",
        "Spend Cap Used",
        "Spend Amount",
        "Service Charge",
        "Service Vat Charge",
        "Total Charge",
        "Vat Charge",
        "Billed Price",
      ],
      linkToMobilePanelFields: [
        "Mpn Fixed Line Digital Account Etc",
        "Mobile Phone Number",
        "Subscription Number",
        "Network Serial Number",
        "Sub Number",
        "Mpn",
      ],
      twoPointFields: ["Current Data Usage GB"],
      rightAlignedFields: [
        "Vat Charge",
        "Service Charge",
        "Total Charge",
        "Total Duration (Mins)",
        "Total Number Of Calls",
        "Total Service Units",
        "Spend Amount",
        "Service Vat Charge",
        "Tax Rate",
        "Total Duration",
        "Total Volume Of Data (GB)",
        "Sum Pre Bundle Actual Duration",
        "Spend Cap Amount",
        "Spend Cap Used",
        "Bundle Not Used Percentage",
        "Service Price",
        "Billed Price",
        "Total Number Of Texts",
        "Total Number Of Voice Calls",
        "Total Volume Of Data",
        "Call Duration",
        "Call Time",
        "Invoice Frequency In Days",
        "Invoice Frequency In Months",
        "Volume Of Data",
        "Current Data Usage GB",
      ],
      timeFields: ["Raised Time", "Bar Time"],
      dataItems: [],
      loading: false,
      dialog: false,
      globalAlertText:
        "A global alert is an alert for all bundles (not bundles associated with a specific network serial number)",
      showTitleToolTip: false,
      options: {
        dataTableName: this.tableName,
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 10,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      headers: [],
      searchValue: "",
      lowerThresholdTextHint:
        "Lower threshold must be a lower percent value than higher threshold. An alert will be sent when the lower threshold is reached.",
      upperThresholdTextHint:
        "Upper threshold must be a higher percent value than lower threshold. An alert will be sent when the upper threshold is reached.",
      textHint: "",
      alertText:
        "A bundle alert fires when a bundle reaches or exceeds one of two set threshold percentages. Bundle alerts can be either global (all bundles) or linked to a specific network serial number.",
      alertToDelete: {},
      excelDownloadLink: "",
      canSearchBy: [],
      hasSearched: false,
      canExport: false,
      initialLoad: true,
      markAll: false,
      markAlertId: 0,
      loadedWithSearchParam: "",
      sortValues: [],
      sortOrders: [],
      dataTableFilters: [],
      tableSwapLoading: false,
      alertErrorMessage: [],
      tableTitle: "",
      // Table title should really be returned in @TableHolder from backend.
      tablePairs: {
        bundle_line: ["BundleLine", "Bundle Utilisation"],
        cdr_line: ["CDRLine", "CDR Report"],
        call_class_landing_line: [
          "CallClassLateLandingLine",
          "Call Class Late Landing",
        ],
        call_class_line: ["CallClassLine", "Call Class"],
        data_report_line: ["DataReportLine", "Subscriptions"],
        diary_events_line: ["DiaryEventsLine", "Service Change Log"],
        invoice_line: ["InvoiceLine", "Invoice Itemisation"],
        non_cc_bar_line: ["NonCCBarLine", "Service Bars"],
        service_report_line: ["ServiceReportLine", "Subscribers Services"],
        cdr_summary_record: [
          "CDRSummaryRecord",
          "Current Out Of Bundle Class Spend",
        ],
        aggregate_invoice_line: ["AggregateInvoiceLine", "Invoices"],
        aggregate_bundle_line: [
          "AggregateBundleLine",
          "Bundle Utilisation Summary",
        ],
        portal_alert: ["PortalAlert", "Alert Rules Manager"],
        alert_record: ["AlertRecord", "Alert History"],
        delete_alert_audit_line: ["DeleteAlertAuditLine", "Alert Delete Audit"],
        read_alert_audit_line: ["ReadAlertAuditLine", "Alert Read Audit"],
        current_data_usage_line: ["CurrentDataUsageLine", "Current Data Usage"],
        aggregate_cdr_summary_record: [
          "AggregateCdrSummaryRecord",
          "Current Out Of Bundle Spend",
        ],
        service_response_line: ["ServiceResponseLine", "Service Requests"],
      },
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.searchInProgress) {
          this.getItems();
        }
      },
      deep: true,
    },
    searchValue: function (newVal, oldVal) {
      if (newVal == "") {
        this.hasSearched = false;
        this.getItems();
      }
    },
    "$route.params": function (newVal, oldVal) {
      this.initialLoad = true;
      this.tableSwapLoading = true;
      this.headers = [];

      this.hasSearched = false;
      this.searchValue = "";

      this.sortValues = [];
      this.sortOrders = [];
      this.dataTableFilters = [];

      var tempOptions = {
        dataTableName: this.tablePairs[newVal.tablename][0],
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 10,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [],
      };

      this.tableTitle = this.tablePairs[newVal.tablename][1];

      if (this.$route.params.tablename == "cdr_summary_record") {
        this.showTitleToolTip = true;
      } else {
        this.showTitleToolTip = false;
      }

      this.loadedWithSearchParam = "";
      this.options = tempOptions;

      this.getNumbers();
    },
  },
  methods: {
    alertTypeSelected(type) {
      this.newPortalAlert.type = type;

      switch (this.newPortalAlert.type) {
        case "BUNDLE":
          this.alertText =
            "A bundle alert fires when a bundle reaches or exceeds one of two set threshold percentages. Bundle alerts can be either global (all bundles) or linked to a specific network serial number.";
          this.globalAlertText =
            "A global alert is an alert for all bundles (not bundles associated with a specific network serial number)";

          this.lowerThresholdTextHint =
            "Lower threshold must be a lower percent value than higher threshold. An alert will be sent when the lower threshold is reached.";
          this.upperThresholdTextHint =
            "Upper threshold must be a higher percent value than lower threshold. An alert will be sent when the upper threshold is reached.";
          this.alertSymbol = "%";
          break;
        case "DATA":
          this.alertText =
            "A data alert fires when data usage exceeds one of two set data thresholds. Data alerts can be either global (all network serial numbers) or linked to a specific network serial number.";
          this.globalAlertText =
            "A global alert is an alert for all network serial numbers (not data usage associated with a speicfic network serial number)";

          this.lowerThresholdTextHint =
            "Lower threshold must be a lower decimal value (GB data) than higher threshold. An alert will be sent when the lower threshold is reached.";
          this.upperThresholdTextHint =
            "Upper threshold must be a higher decimal value (GB data) that lower threshold. An alert will be sent when the upper threshold is reached.";
          this.alertSymbol = "GB";
          break;
        case "SPEND":
          this.alertText =
            "A spend alert fires when out of bundle spend exceeds one of two set amount thresholds. Spend alerts can be either global (all network serial numbers) or linked to a specific network serial number.";
          this.globalAlertText =
            "A global alert is an alert for all network serial numbers (not spend associated with a specific network serial number)";
          this.lowerThresholdTextHint =
            "Lower threshold must be a lower decimal (£) value than higher threshold. An alert will be sent when the lower threshold is reached.";
          this.upperThresholdTextHint =
            "Upper threshold must be a higher decimal (£) value that lower threshold. An alert will be sent when the upper threshold is reached.";
          this.alertSymbol = "£";
          break;
      }
    },
    getAllChangeRequests() {
      this.exportInProgress = true;
      axios
        .get(
          "/api/proposition/get-change-requests/" + this.settings.currentAccount
        )
        .then((response) => {
          this.exportInProgress = false;
          this.allAccountChangeRequests = response.data.data;
          var resultAsCsv =
            "Account Number, Allocated To, Completion Date, Customer Account, Partner Stocklist, Request Number, Request Time, Request Type, Requested By, Status\n";

          for (var k = 0; k < this.allAccountChangeRequests.length; k++) {
            var r = this.allAccountChangeRequests[k];

            var customerAccount =
              r.customer_account == null
                ? ""
                : r.customer_account.replaceAll(",", "");
            var partnerStocklist =
              r.partner_stockist == null
                ? ""
                : r.partner_stockist.replaceAll(",", "");
            var requestedBy =
              r.requested_by == null ? "" : r.requested_by.replaceAll(",", "");
            var allocatedTo =
              r.allocated_to == null ? "" : r.allocated_to.replaceAll(",", "");

            resultAsCsv +=
              r.account_no +
              "," +
              allocatedTo +
              "," +
              r.completion_date +
              "," +
              customerAccount +
              "," +
              partnerStocklist +
              "," +
              r.request_no +
              "," +
              r.request_time +
              "," +
              r.request_type +
              "," +
              requestedBy +
              "," +
              r.status +
              "\n";
          }

          var element = document.createElement("a");
          element.setAttribute(
            "href",
            "data:text/plain;charset=utf-8," + encodeURIComponent(resultAsCsv)
          );
          element.setAttribute(
            "download",
            "export" + Math.random().toString(36).substring(2) + ".csv"
          );

          element.style.display = "none";
          document.body.appendChild(element);

          element.click();

          document.body.removeChild(element);
        })
        .catch((error) => {
          this.exportInProgress = false;
          alert(error);
        });
    },
    openAddDialog() {
      this.newPortalAlert = {
        id: 0,
        name: "",
        description: "",
        email: "",
        global: false,
        type: "",
        networkSerialNumber: "",
        active: true,
        lowerThreshold: 0,
        upperThreshold: 0,
        accountNumber: "",
        type: "BUNDLE",
      };

      this.alertSymbol = "%";

      this.alertErrorMessage = [];
      this.addDialog = true;
      this.tabNumber = 0;
      this.alertText =
        "A bundle alert fires when a bundle reaches or exceeds one of two set threshold percentages. Bundle alerts can be either global (all bundles) or linked to a specific network serial number.";
      this.globalAlertText =
        "A global alert is an alert for all bundles (not bundles associated with a specific network serial number)";
      this.lowerThresholdTextHint =
        "Lower threshold must be a lower percent value than higher threshold. An alert will be sent when the lower threshold is reached.";
      this.upperThresholdTextHint =
        "Upper threshold must be a higher percent value than lower threshold. An alert will be sent when the upper threshold is reached.";
    },

    lowerThreshChanged() {
      if (this.newPortalAlert.lowerThreshold > 100) {
        this.newPortalAlert.lowerThreshold = 100;
      }
    },

    getDataItemById(id) {
      for (var i = 0; i < this.dataItems.length; i += 1) {
        var dataItem = this.dataItems[i];
        if (dataItem.id == id) {
          return dataItem;
        }
      }
    },
    confirmAddAlert() {
      this.alertErrorMessage = [];

      if (this.newPortalAlert.email.trim().length == 0) {
        this.alertErrorMessage.push("No email entered");
      }

      if (
        this.newPortalAlert.global == false &&
        this.newPortalAlert.networkSerialNumber.trim().length == 0
      ) {
        this.alertErrorMessage.push(
          "No network serial number entered for non-global alert"
        );
      }

      if (
        this.newPortalAlert.lowerThreshold >= this.newPortalAlert.upperThreshold
      ) {
        this.alertErrorMessage.push(
          "Lower alert threshold must be less than upper alert threshold"
        );
      }

      if (this.alertErrorMessage.length == 0) {
        axios
          .post("/api/mbe/add-alert", this.newPortalAlert)
          .then((response) => {
            this.getItems();
          })
          .catch((error) => {
            alert(error);
          });

        this.addDialog = false;
      }
    },
    formatTime(time) {
      var timeString = "" + time;
      if (timeString.length == 5) {
        timeString =
          "0" +
          timeString[0] +
          ":" +
          timeString[1] +
          timeString[2] +
          ":" +
          timeString[3] +
          timeString[4];
      } else if (timeString.length == 6) {
        timeString =
          timeString[0] +
          timeString[1] +
          ":" +
          timeString[2] +
          timeString[3] +
          ":" +
          timeString[4] +
          timeString[5];
      }

      return timeString;
    },
    clear() {
      this.searchValue = "";
      this.hasSearched = false;
      this.getItems();
    },
    confirmMarkAlert() {
      if (!this.markAll) {
        axios
          .post("/api/mbe/mark-alert/" + this.markAlertId)
          .then((response) => {
            this.getItems();

            this.$emit("update-alert-bell");

            this.markDialog = false;
          })
          .catch((error) => {
            alert(error);
          });
      } else {
        axios
          .post("/api/mbe/mark-all-alert")
          .then((response) => {
            this.getItems();

            this.$emit("update-alert-bell");

            this.markDialog = false;
          })
          .catch((error) => {
            alert(error);
          });
      }
    },
    markAlertAsRead(alertId, markAll) {
      this.markAll = markAll;
      this.markAlertId = alertId;
      this.markDialog = true;
    },
    buildDateString(day, month, year) {
      var dayString = "" + day;
      var monthString = "" + month;

      if (dayString.length == 1) {
        dayString = "0" + dayString;
      }

      if (monthString.length == 1) {
        monthString = "0" + monthString;
      }

      return dayString + "/" + monthString + "/" + year;
    },
    search(isFreshRequest) {
      this.loading = true;

      /** If attempt to search without search value then ignore request. **/
      if (this.searchValue.length == 0) {
        return;
      }

      var itemsPerPage = 10;
      var skip = 0;

      /** If not making a fresh request (not changing table page with an active search request) then get number of records to skip. **/
      if (!isFreshRequest) {
        itemsPerPage = this.options.itemsPerPage;
        if (this.options.page > 1)
          skip = (this.options.page - 1) * this.options.itemsPerPage;
      }

      var searchRequest = {
        searchValue: this.searchValue.trim(),
        entityToSearch: this.$route.params.tablename,
        numberOfRecordsRequired: itemsPerPage,
        numberOfResultsToSkip: skip,
        sortBy: this.sortValues,
        sortDesc: this.sortOrders,
        isInitialRequest: this.initialLoad,
        dataTableFilters: this.dataTableFilters,
      };

      this.hasSearched = true;
      this.searchInProgress = true;

      if (isFreshRequest == true) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
      }

      axios
        .post("/api/mbe/data-table-search-request", searchRequest)
        .then((response) => {
          if (this.initialLoad == true) {
            this.dataTableFilters = response.data.tableFilters;
            this.sortValues = [response.data.defaultOrderField];

            var tSortOrder =
              response.data.defaultOrder == "DESC" ? true : false;
            this.sortOrders = [tSortOrder];

            this.initialLoad = false;
          }

          let items = response.data.views;
          this.buildColumnValues(items);
          this.totalItems = response.data.numberOfRecords;

          this.canExport = response.data.canExport;

          this.buildTableHeaders(items, response);
          this.setCanSearchBy(response);

          if (this.options.itemsPerPage > 0) {
            items = items.slice(
              (this.options.page - 1) * this.options.itemsPerPage,
              this.options.page * this.options.itemsPerPage
            );
          }

          this.dataItems = response.data.views;
          this.loading = false;
          this.tableSwapLoading = false;
          this.searchInProgress = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
    formatPropertyNameAsHeader(propertyName) {
      propertyName = propertyName.replace(/([A-Z])/g, " $1");
      propertyName = (
        propertyName.charAt(0).toUpperCase() + propertyName.slice(1)
      ).trim();
      return propertyName;
    },
    confirmDeleteAlert() {
      axios
        .delete("/api/mbe/delete-alert/" + this.alertToDelete)
        .then((response) => {
          this.getItems();
          this.deleteDialog = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
    deletePortalAlert(alert) {
      this.deleteDialog = true;
      this.alertToDelete = alert;
    },
    setCanSearchBy(response) {
      this.canSearchBy = response.data.canSearchBy;

      this.textHint =
        "Press Enter to Search the Following fields: " +
        this.formatPropertyNameAsHeader(
          this.canSearchBy.toString().replace(/,/g, ", ")
        );
    },
    buildColumnValues(items) {
      if (
        this.$route.params.tablename == "alert_record" ||
        this.$route.params.tablename == "portal_alert" ||
        this.$route.params.tablename == "delete_alert_audit_line" ||
        this.$route.params.tablename == "read_alert_audit_line"
      ) {
        for (var itemIndex in items) {
          var tItem = items[itemIndex];

          if (tItem.global) {
            tItem["globalOrMpn"] = "GLOBAL";
          } else {
            tItem["globalOrMpn"] = tItem.networkSerialNumber;
          }

          if (tItem.hasOwnProperty("isRead")) {
            tItem.isRead = tItem.isRead + ":" + tItem.id;
          }

          if (
            this.$route.params.tablename == "portal_alert" ||
            this.$route.params.tablename == "delete_alert_audit_line"
          ) {
            switch (tItem.type) {
              case "BUNDLE": {
                tItem.upperThreshold = tItem.upperThreshold.toFixed(2) + "%";
                tItem.lowerThreshold = tItem.lowerThreshold.toFixed(2) + "%";
                break;
              }
              case "DATA": {
                tItem.upperThreshold = tItem.upperThreshold.toFixed(2) + " GB";
                tItem.lowerThreshold = tItem.lowerThreshold.toFixed(2) + " GB";
                break;
              }
              case "SPEND": {
                tItem.upperThreshold = "£" + tItem.upperThreshold.toFixed(2);
                tItem.lowerThreshold = "£" + tItem.lowerThreshold.toFixed(2);
                break;
              }
            }
          }

          if (
            this.$route.params.tablename == "alert_record" ||
            this.$route.params.tablename == "read_alert_audit_line"
          ) {
            switch (tItem.type) {
              case "BUNDLE": {
                tItem.thresholdExceeded =
                  tItem.thresholdExceeded.toFixed(2) + "%";
                tItem.currentUsage = tItem.currentUsage.toFixed(2) + "%";
                break;
              }
              case "DATA": {
                tItem.thresholdExceeded =
                  tItem.thresholdExceeded.toFixed(2) + " GB";
                tItem.currentUsage = tItem.currentUsage.toFixed(2) + " GB";
                break;
              }
              case "SPEND": {
                tItem.thresholdExceeded =
                  "£" + tItem.thresholdExceeded.toFixed(2);
                tItem.currentUsage = "£" + tItem.currentUsage.toFixed(2);
                break;
              }
            }
          }
        }
      }

      if (
        this.$route.params.tablename == "aggregate_invoice_line" ||
        this.$route.params.tablename == "invoice_line"
      ) {
        for (var itemIndex in items) {
          var tItem = items[itemIndex];
          if (tItem.totalDuration > 0) {
            tItem.totalDuration = (tItem.totalDuration / 60).toFixed(2);
          }
        }
      } else if (this.$route.params.tablename == "call_class_line") {
        for (var itemIndex in items) {
          var tItem = items[itemIndex];
          if (tItem.totalDuration > 0) {
            tItem.totalDuration = (tItem.totalDuration / 60).toFixed(2);
          }

          if (tItem.totalVolumeOfData > 0) {
            tItem.totalVolumeOfData = tItem.totalVolumeOfData / 1000000;
          }
        }
      } else if (this.$route.params.tablename == "service_response_line") {
        for (var itemIndex in items) {
          var tItem = items[itemIndex];

          if (tItem.error == true && !tItem.status) {
            tItem.status = "Failed";
          } else if (tItem.error == false && !tItem.status) {
            tItem.status = "Completed";
          }

          console.log("tItem", tItem);
        }
      }
    },
    buildTableHeaders(items, response) {
      if (this.headers.length == 0) {
        for (var prop in items[0]) {
          var headerName = this.formatPropertyNameAsHeader(prop);

          var tabName = this.$route.params.tablename;

          if (
            headerName == "Id" &&
            (tabName == "portal_alert" || tabName == "alert_record")
          ) {
            continue;
          }

          if (
            (tabName == "alert_record" ||
              tabName == "portal_alert" ||
              tabName == "read_alert_audit_line" ||
              tabName == "delete_alert_audit_line") &&
            (headerName == "Network Serial Number" || headerName == "Global")
          ) {
            if (headerName == "Network Serial Number") {
              this.headers.push({
                text: "Global / MPN",
                value: "globalOrMpn",
                sortable: false,
                align: "start",
                color: "white",
                sortDesc: true,
              });
            }

            if (tabName != "alert_record") {
              continue;
            }
          }

          // This is a quick fix but ideally in @TableHolder object from backend it should have an 'alias' field for each column.
          // But for now this will do.
          if (headerName == "Id") {
            headerName = "ID";
          } else if (headerName == "Sum Sp Billed Call Price") {
            headerName = "Spend Amount";
          } else if (
            headerName == "Total Duration" &&
            (tabName == "aggregate_invoice_line" ||
              tabName == "invoice_line" ||
              tabName == "call_class_line")
          ) {
            headerName = "Total Duration (Mins)";
          } else if (
            headerName == "Total Volume Of Data" &&
            tabName == "call_class_line"
          ) {
            headerName = "Total Volume Of Data (GB)";
          } else if (headerName == "Date From Import File") {
            headerName = "Period End";
          } else if (headerName == "Current Data Usage GB") {
            headerName = "Current Data Usage GB";
          } else if (headerName == "Bundle Allocation Number") {
            headerName = "Bundle Number";
          } else if (headerName == "Threshold Exceeded") {
            headerName = "Threshold";
          }

          var tempHeader = {
            text: headerName,
            value: prop,
            sortable: response.data.canOrderBy.includes(prop) ? true : false,
            align: this.rightAlignedFields.includes(headerName)
              ? "right"
              : "start",
            color: "white",
            sortDesc: true,
          };

          this.headers.push(tempHeader);
        }

        if (
          this.$route.params.tablename == "portal_alert" &&
          items.length > 0
        ) {
          this.headers.push({
            text: "Delete",
            value: "id",
            sortable: false,
            align: "start",
            color: "white",
            sortDesc: true,
          });
        }
      }
    },
    getNumbers() {
      if (
        this.$route.params.tablename == "portal_alert" &&
        this.allNumbersForAccount.length == 0
      ) {
        axios
          .get("/api/mbe/mobile-numbers")
          .then((response) => {
            this.allNumbersForAccount = response.data;
          })
          .catch((error) => {
            alert(error);
          });
      }
    },
    exportTable() {
      this.dialog = false;
      this.exportInProgress = true;
      var exportRequest = {
        entityToSearch: this.$route.params.tablename,
        searchValue: this.searchValue.trim(),
        sortBy: this.sortValues,
        sortDesc: this.sortOrders,
        dataTableFilters: this.dataTableFilters,
      };

      axios
        .post("/api/mbe/export-table-request", exportRequest)
        .then((response) => {
          if (response.data != null && response.data != "") {
            document.getElementById("exportLink").click();
          }
          setTimeout(() => {
            this.exportInProgress = false;
          }, 1000);
        })
        .catch((error) => {
          alert(error);
        });
    },
    cloneOptions(optionsCopyPass) {
      var optionsCopy = {};

      if (optionsCopyPass == null) {
        optionsCopy = JSON.parse(JSON.stringify(this.options));
      } else {
        optionsCopy = optionsCopyPass;
      }

      return optionsCopy;
    },
    getItems: _.debounce(function (sortByValue, optionsCopyPass) {
      this.loading = true;
      var paramSearchValue = this.$route.params.initialSearchValue;

      if (this.initialLoad == true) {
        this.tableTitle = this.tablePairs[this.$route.params.tablename][1];

        if (paramSearchValue != null) {
          // This is not ideal but this is how it works:
          // If you visit the invoice_line report page and an 'i' is placed in the URL
          // before the invoice number then the front end will request a 'hidden' filter
          // for the invoice number.
          // Really, this should be handled in backend and filters should have the option of being 'hidden'.
          if (
            this.$route.params.initialSearchValue.toString().startsWith("i")
          ) {
            paramSearchValue = paramSearchValue.substring(1);

            this.loadedWithSearchParam = paramSearchValue;
            this.dataTableFilters = [
              {
                filterDisplayName: "Invoice Number",
                filterFieldName: "invoiceNumber",
                filterOffValue: null,
                filterOnValue: null,
                filterOptions: null,
                filterSubType: "search_equals",
                filterType: "search",
                filterValue: paramSearchValue,
                filterIsActive: true,
              },
              {
                filterDisplayName: "Exclude Zero Spend Charges",
                filterFieldName: "serviceCharge",
                filterOffValue: "1",
                filterOnValue: "0",
                filterOptions: null,
                filterSubType: "toggle_not_equal",
                filterType: "check_box",
                filterValue: "0",
                filterIsActive: true,
              },
            ];

            this.searchValue = "";
          } else if (this.$route.params.initialSearchValue == "filter-active") {
            this.searchValue = "";
          } else {
            this.searchValue = paramSearchValue;
            this.search(true);
            return;
          }
        }
      }

      var optionsCopy = this.cloneOptions(optionsCopyPass);

      /** If sorting by a new value then add this to options and update table header icons to reflect this. **/
      if (sortByValue != null) {
        this.sortValues = [sortByValue.value];
        this.sortOrders = [sortByValue.sortDesc];

        sortByValue.sortDesc = !sortByValue.sortDesc;

        for (var i = 0; i < this.headers.length; i += 1) {
          if (sortByValue.value != this.headers[i].value) {
            this.headers[i].sortDesc = true;
          }
        }
      }

      optionsCopy.sortBy = this.sortValues;
      optionsCopy.sortDesc = this.sortOrders;
      optionsCopy.dataTableName =
        this.tablePairs[this.$route.params.tablename][0];

      const { sortBy, sortDesc, page, itemsPerPage } = optionsCopy;

      /** If this was a data request made while a search request was active
       *  and not a standard data request then move to search function. **/
      if (this.hasSearched) {
        this.search(false);
        return;
      }

      if (optionsCopy.sortBy[0] == undefined) {
        optionsCopy.sortBy = ["id"];
        optionsCopy.sortDesc = [false];
      }

      if (this.initialLoad == true) {
        optionsCopy.sortBy = [];
        optionsCopy.sortDesc = [];
      }

      optionsCopy.isInitialRequest = this.initialLoad;
      optionsCopy.dataTableFilters = this.dataTableFilters;

      axios
        .post("/api/mbe/data-table-request", optionsCopy)
        .then((response) => {
          let items = response.data.views;
          this.canExport = response.data.canExport;

          if (this.initialLoad == true) {
            if (this.dataTableFilters.length == 0) {
              this.dataTableFilters = response.data.tableFilters;
            }

            this.sortValues = [response.data.defaultOrderField];
            var tSortOrder =
              response.data.defaultOrder == "DESC" ? true : false;
            this.sortOrders = [tSortOrder];

            // Temp.
            if (
              this.initialLoad &&
              this.$route.params.initialSearchValue == "filter-active"
            ) {
              for (var i = 0; i < this.dataTableFilters.length; i++) {
                var tabFilter = this.dataTableFilters[i];
                if (tabFilter.filterDisplayName == "Only Show Unread Alerts") {
                  tabFilter.filterValue = "0";
                }
              }
              this.initialLoad = false;
              this.getItems();
            }

            this.initialLoad = false;
          }

          if (this.initialLoad == true && this.dataTableFilters.length == 0) {
            this.dataTableFilters = response.data.tableFilters;
          }

          /** If no results available -> return. **/
          if (items == null || items == undefined) {
            this.loading = false;
            return;
          }

          /** If we have no headers (initial load or table has changed) then build the table headers. **/
          this.buildTableHeaders(items, response);
          this.totalItems = response.data.numberOfRecords;
          this.buildColumnValues(items);

          this.dataItems = response.data.views;
          this.setCanSearchBy(response);
          this.loading = false;
          this.tableSwapLoading = false;
        })
        .catch((error) => {
          alert(error);
        });
    }, 100),
  },
  mounted() {
    this.excelDownloadLink = window.location.origin + "/ExcelFileDownload";
    var element = document.querySelector("html");
    element.classList.remove("disable-scroll");

    this.getNumbers();

    if (this.$route.params.tablename == "cdr_summary_record") {
      this.showTitleToolTip = true;
    } else {
      this.showTitleToolTip = false;
    }
  },
};
</script>
